import { Flex, Text } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { InputErrorText, InputHelpText } from '../Text';
import ComboboxComponent from './main';

const ComboBox = forwardRef(function ComboBox({ helpText, label, errorText, ...rest }, ref) {
  const labelEl = !!label && !rest.renderLabelInElementFareLeft && !rest.renderLabelInElementFareRight && (
    <Text
      ml='5px'
      size='1'
      as='label'
    >
      {label}
    </Text>
  );

  const comboBoxEl = (
    <ComboboxComponent
      {...rest}
      label={label}
      ref={ref}
    />
  );

  const helpTextEl =
    helpText && typeof helpText === 'function' ? (
      helpText()
    ) : (
      <InputHelpText
        ml='5px'
        size='1'
      >
        {helpText}
      </InputHelpText>
    );

  const errorTextEl = !!errorText && (
    <InputErrorText
      ml='5px'
      size='1'
    >
      {errorText}
    </InputErrorText>
  );

  return (
    <Flex direction='column'>
      {labelEl}
      {comboBoxEl}
      {errorTextEl || helpTextEl}
    </Flex>
  );
});

ComboBox.propTypes = {
  ...ComboboxComponent.propTypes,
  helpText: PropTypes.string,
  label: PropTypes.string,
  errorText: PropTypes.string,
  renderLabelInElementFareLeft: PropTypes.bool,
  renderLabelInElementFareLeftFareRight: PropTypes.bool,
};

export default ComboBox;
export { ComboboxComponent };
